import { decode } from 'html-entities';

import type { SvgIconNames } from 'src/components/Svg/icons-types';

type USPItem = { title: string; description?: string; icon: SvgIconNames; link: string };

type USPItems = USPItem[];

function minifyHTMl(input?: string) {
    if (!input) {
        return undefined;
    }

    return input
        .replace(/[\r\n\t]+/g, ' ')
        .replace(/\s{2,}/g, ' ')
        .trim();
}

export function parseUspCmsBlock(input?: string): USPItems {
    const cmsBlockHtml = minifyHTMl(input);
    const start = cmsBlockHtml?.indexOf('[[') ?? -1;
    const end = cmsBlockHtml?.indexOf(']]', start + 2) ?? -1;

    if (!cmsBlockHtml || start === -1 || end === -1) {
        return [];
    }

    const configString = cmsBlockHtml.slice(start + 2, end).trim();

    if (!configString) {
        return [];
    }

    try {
        const parsedArray = JSON.parse('[' + configString + ']') as USPItems;
        const uspItems: USPItems = [];

        parsedArray.forEach((item) => {
            const uspItem: USPItem = {
                description: undefined,
                icon: item.icon,
                link: item.link,
                title: '',
            };

            if (item.description) {
                uspItem.description = decode(item.description.trim());
            }

            if (item.title) {
                uspItem.title = decode(item.title.trim());
            }

            if (uspItem.title && uspItem.icon && uspItem.link) {
                uspItems.push(uspItem);
            }
        });

        return uspItems;
    } catch (error) {
        console.error('Error parsing USP CMS block', error);
    }

    return [];
}
